import { cn } from '@/lib/utils';

import { reduceStrapiTheme, StrapiTheme } from '@/theme/themeProviderUtils';

import { BadgeProps } from '@/components/atoms/badge';

export const MAX_TAG_AMOUNT_BEFORE_FOLD = 7;

export const mutualBadgeProps: BadgeProps = {
  size: 'l',
  classNames: {
    root: 'cursor-pointer',
  },
};
export const getSelectedTagProps = ({
  theme,
}: {
  theme?: StrapiTheme;
}): BadgeProps => ({
  ...mutualBadgeProps,
  color: 'brand',
  variant: theme && reduceStrapiTheme(theme) === 'light' ? 'soft' : 'filled',
  classNames: {
    root: cn('border', mutualBadgeProps.classNames?.root),
  },
});

export const unSelectedTagProps: BadgeProps = {
  ...mutualBadgeProps,
  color: 'gray',
  variant: 'soft',
  classNames: {
    root: cn(mutualBadgeProps.classNames?.root),
  },
};

export const SCRAPING_CARD_DATA_TRACKER_COMPONENT = 'scraping-template-card';

export const SCRAPING_TEMPLATE_LIBRARY_NUMBER_OF_ROWS = 3;
